import { render } from "./pageTitle.vue?vue&type=template&id=dea262f0"
const script = {}

import "./pageTitle.vue?vue&type=style&index=0&id=dea262f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__